import React from 'react';
import Points from 'components/Points';
import { MONTHLY_MAINTENANCE_FEE_POINTS } from 'config/fees';
import './SavingsBanner.css';

interface SavingsBannerProps {
  eliteSince: string | null | undefined;
}

function monthsElapsed(fromISOString: string | null | undefined): number {
  if (!fromISOString) return 0;
  const from = new Date(fromISOString);
  const now = new Date();
  if (Number.isNaN(from.getTime())) return 0;
  let months = (now.getFullYear() - from.getFullYear()) * 12 + (now.getMonth() - from.getMonth());
  if (now.getDate() < from.getDate()) months -= 1;
  return Math.max(0, months);
}

export default function SavingsBanner({ eliteSince }: SavingsBannerProps) {
  // Fee is waived for the current month from day one, and again at each monthly anniversary.
  // Month 0 (newly subscribed) → 100 pts; month 1 anniversary → 200 pts; etc.
  const months = monthsElapsed(eliteSince);
  const saved = eliteSince ? (months + 1) * MONTHLY_MAINTENANCE_FEE_POINTS : 0;

  return (
    <div className="elite-savings-banner">
      <div className="elite-savings-banner__headline">
        <span>You&rsquo;ve saved</span>
        <Points points={saved} type="small" />
        <span>in waived fees</span>
      </div>
      <p className="elite-savings-banner__body">
        As an Elite member, your monthly maintenance fee is waived. Every month you stay Elite,
        that&rsquo;s another{' '}
        <span className="elite-savings-banner__inline-points">
          <Points points={MONTHLY_MAINTENANCE_FEE_POINTS} type="small" />
        </span>{' '}
        back in your pocket.
      </p>
    </div>
  );
}
